import GraphQLExceptionHandler, {
  ErrorBag,
  GraphQLException,
} from '@/handler/GraphQLExceptionHandler'
import i18n from '@/config/i18n'

export type HandlerType = (err: Error) => ErrorBag

const factory: (err: Error) => HandlerType = (err) => {
  if (err instanceof GraphQLException) {
    return GraphQLExceptionHandler
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (_: Error) => {
    const errorBag = new ErrorBag()
    errorBag.add('errors.unknown', i18n.tc('errors.unknown'))
    return errorBag
  }
}

export default factory
